import Index from './Index';
import Budgets from './Budgets';
import {
  Switch,
  Route,
  useRouteMatch,
} from "react-router-dom";

let CartProducts = (props) => {
  let { path } = useRouteMatch();
  const theme = props.theme;

  return <>
    <Switch>
      <Route exact path={`${path}`}>
        <Index theme={theme} setShowMenu={props.setShowMenu} />
      </Route>
      <Route exact path={`${path}/orcamento`}>
        <Budgets theme={theme} />
      </Route>
    </Switch>
  </>
}

export default CartProducts;
